// utils/authUtils.js - Kimlik doğrulama ve yetkilendirme yardımcı fonksiyonları

// JWT token'ını localStorage'dan al
export const getToken = () => {
  return localStorage.getItem('token');
};

// Yetkilendirme header'ını oluştur
export const getAuthHeader = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Kullanıcı bilgilerini localStorage'dan al
export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Kullanıcının giriş yapmış olup olmadığını kontrol et
export const isAuthenticated = () => {
  return !!getToken();
};

// Kullanıcının belirli bir role sahip olup olmadığını kontrol et
export const hasRole = (role) => {
  const user = getUser();
  if (!user) return false;
  
  if (Array.isArray(role)) {
    return role.includes(user.role);
  }
  
  return user.role === role;
};

// Kullanıcının admin olup olmadığını kontrol et
export const isAdmin = () => {
  return hasRole('admin');
};

// Kullanıcının CASI olup olmadığını kontrol et
export const isCasi = () => {
  return hasRole('casi');
}; 